import behaviourSettings from "./behaviourSettings"
// import behaviourManage from "./behaviourManage"

const behaviourModules = {
  behaviourSettings
}
export default behaviourModules
